import styled from '@emotion/styled';
import { fontSize } from 'src/assets/fonts-config';

export const SearchBoxMenu = styled('div', { label: 'SearchBoxMenu' })`
    border-bottom: 1px solid #ccc;
    padding: 2px 2px 5px;
`;

export const TabsContent = styled('div', { label: 'TabsContent' })`
    height: 100%;
`;

export const Identfier = styled('td', { label: 'Identfier' })`
    font-size: ${fontSize.small};
    text-align: center;
`;
